import * as z from "zod";

export const getContextualSettings = {
  name: "getContextualSettings" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    contextualMerchantId: z.string().nullable(),
  }),
};
